'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-10 lg:py-20 bg-gradient-to-br from-accent via-accent/90 to-accent text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <Icon name="SparklesIcon" size={40} className="mx-auto mb-3 lg:mb-6 opacity-90 lg:hidden" />
          <Icon name="SparklesIcon" size={64} className="mx-auto mb-6 opacity-90 hidden lg:block" />
          
          <h2 className="text-2xl lg:text-5xl font-bold font-amiri mb-3 lg:mb-6 leading-tight">
            {t('ابدأ التوفير اليوم!', 'Start Saving Today!')}
          </h2>
          
          <p className="text-sm lg:text-2xl mb-5 lg:mb-8 opacity-90 leading-relaxed">
            {t(
              'انضم إلى آلاف العملاء الذين يوفرون مئات الريالات شهرياً مع بطاقات الاشتراك الخاصة بنا',
              'Join thousands of customers saving hundreds of riyals monthly with our subscription cards'
            )}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 justify-center items-center mb-6 lg:mb-12">
            <Link
              href="/subscription-cards"
              className="inline-flex items-center gap-2 px-6 py-3 lg:px-10 lg:py-5 bg-white text-accent rounded-xl font-bold text-sm lg:text-xl transition-premium hover:bg-white/90 hover:shadow-2xl active-press"
            >
              <Icon name="CreditCardIcon" size={20} />
              <span>{t('اشترك الآن', 'Subscribe Now')}</span>
            </Link>

            <Link
              href="/contact-us"
              className="inline-flex items-center gap-2 px-6 py-3 lg:px-10 lg:py-5 bg-white/10 text-white rounded-xl font-bold text-sm lg:text-xl transition-premium hover:bg-white/20 backdrop-blur-sm"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={20} />
              <span>{t('تواصل معنا', 'Contact Us')}</span>
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-4 lg:gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <p className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2 data-text">24/7</p>
              <p className="text-xs lg:text-sm opacity-80">{t('دعم فني', 'Technical Support')}</p>
            </div>
            <div className="text-center">
              <p className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2 data-text">100%</p>
              <p className="text-xs lg:text-sm opacity-80">{t('ضمان الجودة', 'Quality Guarantee')}</p>
            </div>
            <div className="text-center">
              <p className="text-2xl lg:text-4xl font-bold mb-1 lg:mb-2 data-text">50%</p>
              <p className="text-xs lg:text-sm opacity-80">{t('خصم حصري', 'Exclusive Discount')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;